
import { mapState, mapMutations } from 'vuex';
import LocalStorageKeys from '@/constants/LOCAL_STORAGE_KEYS';
import AppFilterSectionUserPropertyDropdownMenu from './AppFilterSectionUserPropertyDropdownMenu';

export default {
  name: 'AppFilterSectionUserProperty',
  components: { AppFilterSectionUserPropertyDropdownMenu },
  props: {
    params: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      OPTIONS: [
        {
          key: 'height',
          name: this.$t('search_bar.user_property.height'),
          unit: 'cm',
          value: 'height'
        },
        {
          key: 'weight',
          name: this.$t('search_bar.user_property.weight'),
          unit: 'kg',
          value: 'weight'
        }
      ],
      selectedUserProperties: {
        height: null,
        weight: null
      }
    };
  },
  computed: {
    ...mapState('userProperties', [
      'isLoadingUserProperties',
      'userWeight',
      'userHeight'
    ]),
    ...mapState('widget', ['isMobile']),
    appliedValue() {
      return [this.userWeight && 'weight', this.userHeight && 'height'].filter(
        v => !!v
      );
    }
  },
  created() {
    const { user_height, user_weight } = this.params;
    if (user_height) this.SET_USER_HEIGHT(user_height);
    if (user_height) this.SET_USER_WEIGHT(user_weight);
  },
  mounted() {
    this.selectedUserProperties['height'] = JSON.parse(
      localStorage.getItem(LocalStorageKeys.USER_HEIGHT)
    );
    this.selectedUserProperties['weight'] = JSON.parse(
      localStorage.getItem(LocalStorageKeys.USER_WEIGHT)
    );
  },
  methods: {
    ...mapMutations('userProperties', ['SET_USER_WEIGHT', 'SET_USER_HEIGHT']),
    onSaveUserProperty(newUserProperties) {
      this.selectedUserProperties = { ...newUserProperties };
      this.setUserPropertyToLocalStorage();
    },
    setUserPropertyToLocalStorage() {
      localStorage.setItem(
        LocalStorageKeys.USER_HEIGHT,
        this.selectedUserProperties['height']
      );
      localStorage.setItem(
        LocalStorageKeys.USER_WEIGHT,
        this.selectedUserProperties['weight']
      );
    },
    onApplyUserProperty() {
      const [oldWeight, oldHeight] = [this.userWeight, this.userHeight];
      const [newWeight, newHeight] = [
        this.selectedUserProperties['weight'],
        this.selectedUserProperties['height']
      ];

      if (oldWeight === newWeight && oldHeight === newHeight) return;

      const params = {};
      if (oldWeight !== newWeight) {
        this.SET_USER_WEIGHT(newWeight);
        params['user_weight'] = newWeight;
      }
      if (oldHeight !== newHeight) {
        this.SET_USER_HEIGHT(newHeight);
        params['user_height'] = newHeight;
      }

      this.$emit('change', params);
    },
    onResetUserProperty() {
      if (!(this.userWeight || this.userHeight)) return;

      this.SET_USER_WEIGHT(null);
      this.SET_USER_HEIGHT(null);
      this.$emit('change', { user_weight: null, user_height: null });
    }
  }
};
